export const codeTransactionData = [
    {
        "country": "Afghanistan",
        "code": "93",
        "iso": "AF",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Albania",
        "code": "355",
        "iso": "AL",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Algeria",
        "code": "213",
        "iso": "DZ",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "American Samoa",
        "code": "1-684",
        "iso": "AS",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Andorra",
        "code": "376",
        "iso": "AD",
        "isTransactions": false,
        "phoneLength": 6
    },
    {
        "country": "Angola",
        "code": "244",
        "iso": "AO",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Anguilla",
        "code": "1-264",
        "iso": "AI",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Antarctica",
        "code": "672",
        "iso": "AQ",
        "isTransactions": false
    },
    {
        "country": "Antigua and Barbuda",
        "code": "1-268",
        "iso": "AG",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Argentina",
        "code": "54",
        "iso": "AR",
        "isTransactions": true,
        "languages": ["en", "es"],
        "phoneLength": 10
    },
    {
        "country": "Armenia",
        "code": "374",
        "iso": "AM",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Aruba",
        "code": "297",
        "iso": "AW",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Australia",
        "code": "61",
        "iso": "AU",
        "isTransactions": true,
        "phoneLength": 9
    },
    {
        "country": "Austria",
        "code": "43",
        "iso": "AT",
        "isTransactions": true,
        "languages": ["en", "de"],
        "phoneLength": 10
    },
    {
        "country": "Azerbaijan",
        "code": "994",
        "iso": "AZ",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Bahamas",
        "code": "1-242",
        "iso": "BS",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Bahrain",
        "code": "973",
        "iso": "BH",
        "isTransactions": true,
        languages: ["en", "ar"],
        "phoneLength": 8
    },
    {
        "country": "Bangladesh",
        "code": "880",
        "iso": "BD",
        "isTransactions": false,
        "phoneLength": 10
    },
    {
        "country": "Barbados",
        "code": "1-246",
        "iso": "BB",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Belarus",
        "code": "375",
        "iso": "BY",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Belgium",
        "code": "32",
        "iso": "BE",
        "isTransactions": true,
        languages: ["en", "nl", "fr", "ar"],
        "phoneLength": 9
    },
    {
        "country": "Belize",
        "code": "501",
        "iso": "BZ",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Benin",
        "code": "229",
        "iso": "BJ",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Bermuda",
        "code": "1-441",
        "iso": "BM",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Bhutan",
        "code": "975",
        "iso": "BT",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Bolivia",
        "code": "591",
        "iso": "BO",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Bosnia and Herzegovina",
        "code": "387",
        "iso": "BA",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Botswana",
        "code": "267",
        "iso": "BW",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Brazil",
        "code": "55",
        "iso": "BR",
        "isTransactions": true,
        languages: ["en","pt","es"],
        "phoneLength": 11
    },
    {
        "country": "British Indian Ocean Territory",
        "code": "246",
        "iso": "IO",
        "isTransactions": false
    },
    {
        "country": "British Virgin Islands",
        "code": "1-284",
        "iso": "VG",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Brunei",
        "code": "673",
        "iso": "BN",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Bulgaria",
        "code": "359",
        "iso": "BG",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Burkina Faso",
        "code": "226",
        "iso": "BF",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Burundi",
        "code": "257",
        "iso": "BI",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Cambodia",
        "code": "855",
        "iso": "KH",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Cameroon",
        "code": "237",
        "iso": "CM",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Canada",
        "code": "1",
        "iso": "CA",
        "isTransactions": true,
        languages: ["en", "fr"],
        "phoneLength": 10
    },
    {
        "country": "Cape Verde",
        "code": "238",
        "iso": "CV",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Cayman Islands",
        "code": "1-345",
        "iso": "KY",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Central African Republic",
        "code": "236",
        "iso": "CF",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Chad",
        "code": "235",
        "iso": "TD",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Chile",
        "code": "56",
        "iso": "CL",
        "isTransactions": true,
        languages: ["en", "es"],
        "phoneLength": 9
    },
    {
        "country": "China",
        "code": "86",
        "iso": "CN",
        "isTransactions": false,
        "phoneLength": 11
    },
    {
        "country": "Christmas Island",
        "code": "61",
        "iso": "CX",
        "isTransactions": false
    },
    {
        "country": "Cocos Islands",
        "code": "61",
        "iso": "CC",
        "isTransactions": false
    },
    {
        "country": "Colombia",
        "code": "57",
        "iso": "CO",
        "isTransactions": false,
        "phoneLength": 10
    },
    {
        "country": "Comoros",
        "code": "269",
        "iso": "KM",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Cook Islands",
        "code": "682",
        "iso": "CK",
        "isTransactions": false,
        "phoneLength": 5
    },
    {
        "country": "Costa Rica",
        "code": "506",
        "iso": "CR",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Croatia",
        "code": "385",
        "iso": "HR",
        "isTransactions": true,
        "phoneLength": 9
    },
    {
        "country": "Cuba",
        "code": "53",
        "iso": "CU",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Curacao",
        "code": "599",
        "iso": "CW",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Cyprus",// to discuss
        "code": "357",
        "iso": "CY",
        "isTransactions": true,
        "phoneLength": 8
    },
    {
        "country": "Czech Republic",
        "code": "420",
        "iso": "CZ",
        "isTransactions": true,
        "phoneLength": 9
    },
    {
        "country": "Democratic Republic of the Congo",
        "code": "243",
        "iso": "CD",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Denmark",
        "code": "45",
        "iso": "DK",
        "isTransactions": true,
        languages: ["en", "da"],
        "phoneLength": 8
    },
    {
        "country": "Djibouti",
        "code": "253",
        "iso": "DJ",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Dominica",
        "code": "1-767",
        "iso": "DM",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Dominican Republic",
        "code": "1-809, 1-829, 1-849",
        "iso": "DO",
        "isTransactions": false,
        "phoneLength": 10
    },
    {
        "country": "East Timor",
        "code": "670",
        "iso": "TL",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Ecuador",
        "code": "593",
        "iso": "EC",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Egypt",
        "code": "20",
        "iso": "EG",
        "isTransactions": false,
        "phoneLength": 10
    },
    {
        "country": "El Salvador",
        "code": "503",
        "iso": "SV",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Equatorial Guinea",
        "code": "240",
        "iso": "GQ",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Eritrea",
        "code": "291",
        "iso": "ER",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Estonia",
        "code": "372",
        "iso": "EE",
        "isTransactions": true,
        languages: ["en", "et"],
        "phoneLength": 8
    },
    {
        "country": "Ethiopia",
        "code": "251",
        "iso": "ET",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Falkland Islands",
        "code": "500",
        "iso": "FK",
        "isTransactions": false,
        "phoneLength": 5
    },
    {
        "country": "Faroe Islands",
        "code": "298",
        "iso": "FO",
        "isTransactions": false,
        "phoneLength": 6
    },
    {
        "country": "Fiji",
        "code": "679",
        "iso": "FJ",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Finland",
        "code": "358",
        "iso": "FI",
        "isTransactions": true,
        languages: ["en", "fi"],
        "phoneLength": 12
    },
    {
        "country": "France",
        "code": "33",
        "iso": "FR",
        "isTransactions": true,
        languages: ["en", "fr", "ar"],
        "phoneLength": 10
    },
    {
        "country": "French Polynesia",
        "code": "689",
        "iso": "PF",
        "isTransactions": false,
        "phoneLength": 6
    },
    {
        "country": "Gabon",
        "code": "241",
        "iso": "GA",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Gambia",
        "code": "220",
        "iso": "GM",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Georgia",
        "code": "995",
        "iso": "GE",
        "isTransactions": true,
        languages: ["en", "ka"],
        "phoneLength": 9
    },
    {
        "country": "Germany",
        "code": "49",
        "iso": "DE",
        "isTransactions": true,
        languages: ["en", "de"],
        "phoneLength": 11
    },
    {
        "country": "Ghana",
        "code": "233",
        "iso": "GH",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Gibraltar",
        "code": "350",
        "iso": "GI",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Greece",
        "code": "30",
        "iso": "GR",
        "isTransactions": false,
        "phoneLength": 10
    },
    {
        "country": "Greenland",
        "code": "299",
        "iso": "GL",
        "isTransactions": false,
        "phoneLength": 6
    },
    {
        "country": "Grenada",
        "code": "1-473",
        "iso": "GD",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Guam",
        "code": "1-671",
        "iso": "GU",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Guatemala",
        "code": "502",
        "iso": "GT",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Guernsey",
        "code": "44-1481",
        "iso": "GG",
        "isTransactions": false,
        "phoneLength": 6
    },
    {
        "country": "Guinea",
        "code": "224",
        "iso": "GN",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Guinea-Bissau",
        "code": "245",
        "iso": "GW",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Guyana",
        "code": "592",
        "iso": "GY",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Haiti",
        "code": "509",
        "iso": "HT",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Honduras",
        "code": "504",
        "iso": "HN",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Hong Kong",
        "code": "852",
        "iso": "HK",
        "isTransactions": true,
        languages: ["en", "zh", "id"],
        "phoneLength": 8
    },
    {
        "country": "Hungary",
        "code": "36",
        "iso": "HU",
        "isTransactions": true,
        "phoneLength": 9
    },
    {
        "country": "Iceland",
        "code": "354",
        "iso": "IS",
        "isTransactions": true,
        "phoneLength": 7
    },
    {
        "country": "India",
        "code": "91",
        "iso": "IN",
        "isTransactions": true,
        "phoneLength": 10
    },
    {
        "country": "Indonesia",
        "code": "62",
        "iso": "ID",
        "isTransactions": false,
        "phoneLength": 10
    },
    {
        "country": "Iran",
        "code": "98",
        "iso": "IR",
        "isTransactions": false,
        "phoneLength": 10
    },
    {
        "country": "Iraq",
        "code": "964",
        "iso": "IQ",
        "isTransactions": false,
        "phoneLength": 10
    },
    {
        "country": "Ireland",
        "code": "353",
        "iso": "IE",
        "isTransactions": true,
        "phoneLength": 9
    },
    {
        "country": "Isle of Man",
        "code": "44-1624",
        "iso": "IM",
        "isTransactions": false,
        "phoneLength": 6
    },
    {
        "country": "Israel",
        "code": "972",
        "iso": "IL",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Italy",
        "code": "39",
        "iso": "IT",
        "isTransactions": true,
        languages: ["en", "it"],
        "phoneLength": 10
    },
    {
        "country": "Ivory Coast",
        "code": "225",
        "iso": "CI",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Jamaica",
        "code": "1-876",
        "iso": "JM",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Japan",
        "code": "81",
        "iso": "JP",
        "isTransactions": true,
        languages: ["en", "ja", "my", "ne","vi","id","zh"],
        "phoneLength": 10
    },
    {
        "country": "Jersey",
        "code": "44-1534",
        "iso": "JE",
        "isTransactions": false,
        "phoneLength": 6
    },
    {
        "country": "Jordan",
        "code": "962",
        "iso": "JO",
        "isTransactions": true,
        languages: ["en", "ar"],
        "phoneLength": 9
    },
    {
        "country": "Kazakhstan",
        "code": "7",
        "iso": "KZ",
        "isTransactions": false,
        "phoneLength": 10
    },
    {
        "country": "Kenya",
        "code": "254",
        "iso": "KE",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Kiribati",
        "code": "686",
        "iso": "KI",
        "isTransactions": false,
        "phoneLength": 5
    },
    {
        "country": "Kosovo",
        "code": "383",
        "iso": "XK",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Kuwait",
        "code": "965",
        "iso": "KW",
        "isTransactions": true,
        languages: ["en", "ar"],
        "phoneLength": 8
    },
    {
        "country": "Kyrgyzstan",
        "code": "996",
        "iso": "KG",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Laos",
        "code": "856",
        "iso": "LA",
        "isTransactions": false,
        "phoneLength": 10
    },
    {
        "country": "Latvia",
        "code": "371",
        "iso": "LV",
        "isTransactions": true ,
        "languages": ["en","lv"],
        "phoneLength": 8
    },
    {
        "country": "Lebanon",
        "code": "961",
        "iso": "LB",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Lesotho",
        "code": "266",
        "iso": "LS",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Liberia",
        "code": "231",
        "iso": "LR",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Libya",
        "code": "218",
        "iso": "LY",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Liechtenstein",
        "code": "423",
        "iso": "LI",
        "isTransactions": true,
        "languages": ["en","de"],
        "phoneLength": 9
    },
    {
        "country": "Lithuania",
        "code": "370",
        "iso": "LT",
        "isTransactions": true ,
        "languages": ["en","lt"],
        "phoneLength": 8
    },
    {
        "country": "Luxembourg",
        "code": "352",
        "iso": "LU",
        "isTransactions": true ,
        "languages": ["en","fr","de"],
        "phoneLength": 9
    },
    {
        "country": "Macao",
        "code": "853",
        "iso": "MO",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Macedonia",
        "code": "389",
        "iso": "MK",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Madagascar",
        "code": "261",
        "iso": "MG",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Malawi",
        "code": "265",
        "iso": "MW",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Malaysia",
        "code": "60",
        "iso": "MY",
        "isTransactions": true,
        "languages": ["en","ms","hi","bn","ta","vi","my"],
        "phoneLength": 9
    },
    {
        "country": "Maldives",
        "code": "960",
        "iso": "MV",
        "isTransactions": true,
        "phoneLength": 7
    },
    {
        "country": "Mali",
        "code": "223",
        "iso": "ML",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Malta",
        "code": "356",
        "iso": "MT",
        "isTransactions": true,
        "phoneLength": 8
    },
    {
        "country": "Marshall Islands",
        "code": "692",
        "iso": "MH",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Mauritania",
        "code": "222",
        "iso": "MR",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Mauritius",
        "code": "230",
        "iso": "MU",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Mayotte",
        "code": "262",
        "iso": "YT",
        "isTransactions": false,
        "phoneLength": 6
    },
    {
        "country": "Mexico",
        "code": "52",
        "iso": "MX",
        "isTransactions": false,
        "phoneLength": 10
    },
    {
        "country": "Micronesia",
        "code": "691",
        "iso": "FM",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Moldova",
        "code": "373",
        "iso": "MD",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Monaco",
        "code": "377",
        "iso": "MC",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Mongolia",
        "code": "976",
        "iso": "MN",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Montenegro",
        "code": "382",
        "iso": "ME",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Montserrat",
        "code": "1-664",
        "iso": "MS",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Morocco",
        "code": "212",
        "iso": "MA",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Mozambique",
        "code": "258",
        "iso": "MZ",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Myanmar",
        "code": "95",
        "iso": "MM",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Namibia",
        "code": "264",
        "iso": "NA",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Nauru",
        "code": "674",
        "iso": "NR",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Nepal",
        "code": "977",
        "iso": "NP",
        "isTransactions": false,
        "phoneLength": 10
    },
    {
        "country": "Netherlands",
        "code": "31",
        "iso": "NL",
        "isTransactions": true ,
        "languages": ["en","nl"],
        "phoneLength": 9
    },
    {
        "country": "Netherlands Antilles",
        "code": "599",
        "iso": "AN",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "New Caledonia",
        "code": "687",
        "iso": "NC",
        "isTransactions": false,
        "phoneLength": 6
    },
    {
        "country": "New Zealand",
        "code": "64",
        "iso": "NZ",
        "isTransactions": true,
        "phoneLength": 9
    },
    {
        "country": "Nicaragua",
        "code": "505",
        "iso": "NI",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Niger",
        "code": "227",
        "iso": "NE",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Nigeria",
        "code": "234",
        "iso": "NG",
        "isTransactions": false,
        "phoneLength": 10
    },
    {
        "country": "Niue",
        "code": "683",
        "iso": "NU",
        "isTransactions": false,
        "phoneLength": 4
    },
    {
        "country": "North Korea",
        "code": "850",
        "iso": "KP",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Northern Mariana Islands",
        "code": "1-670",
        "iso": "MP",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Norway",
        "code": "47",
        "iso": "NO",
        "isTransactions": true ,
        "languages": ["en","no","pl"],
        "phoneLength": 8

    },
    {
        "country": "Oman",
        "code": "968",
        "iso": "OM",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Pakistan",
        "code": "92",
        "iso": "PK",
        "isTransactions": false,
        "phoneLength": 10
    },
    {
        "country": "Palau",
        "code": "680",
        "iso": "PW",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Palestine",
        "code": "970",
        "iso": "PS",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Panama",
        "code": "507",
        "iso": "PA",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Papua New Guinea",
        "code": "675",
        "iso": "PG",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Paraguay",
        "code": "595",
        "iso": "PY",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Peru",
        "code": "51",
        "iso": "PE",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Philippines",
        "code": "63",
        "iso": "PH",
        "isTransactions": false,
        "phoneLength": 10
    },
    {
        "country": "Pitcairn",
        "code": "64",
        "iso": "PN",
        "isTransactions": false
    },
    {
        "country": "Poland",
        "code": "48",
        "iso": "PL",
        "isTransactions": true,
        "languages": ["en","pl"],
        "phoneLength": 9
    },
    {
        "country": "Portugal",
        "code": "351",
        "iso": "PT",
        "isTransactions": true,
        "languages": ["en","pt"],
        "phoneLength": 9
    },
    {
        "country": "Puerto Rico",
        "code": "1-787, 1-939",
        "iso": "PR",
        "isTransactions": false,
        "phoneLength": 10
    },
    {
        "country": "Qatar",
        "code": "974",
        "iso": "QA",
        "isTransactions": true ,
        "languages": ["en","ar"],
        "phoneLength": 8
    },
    {
        "country": "Republic of the Congo",
        "code": "242",
        "iso": "CG",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Reunion",
        "code": "262",
        "iso": "RE",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Romania",
        "code": "40",
        "iso": "RO",
        "isTransactions": true,
        "languages": ["en","ro"],
        "phoneLength": 9
    },
    {
        "country": "Russia",
        "code": "7",
        "iso": "RU",
        "isTransactions": false,
        "phoneLength": 10
    },
    {
        "country": "Rwanda",
        "code": "250",
        "iso": "RW",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Saint Barthelemy",
        "code": "590",
        "iso": "BL",
        "isTransactions": false,
        "phoneLength": 6
    },
    {
        "country": "Saint Helena",
        "code": "290",
        "iso": "SH",
        "isTransactions": false,
        "phoneLength": 4
    },
    {
        "country": "Saint Kitts and Nevis",
        "code": "1-869",
        "iso": "KN",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Saint Lucia",
        "code": "1-758",
        "iso": "LC",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Saint Martin",
        "code": "590",
        "iso": "MF",
        "isTransactions": false,
        "phoneLength": 6
    },
    {
        "country": "Saint Pierre and Miquelon",
        "code": "508",
        "iso": "PM",
        "isTransactions": false,
        "phoneLength": 6
    },
    {
        "country": "Saint Vincent and the Grenadines",
        "code": "1-784",
        "iso": "VC",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Samoa",
        "code": "685",
        "iso": "WS",
        "isTransactions": false,
        "phoneLength": 5
    },
    {
        "country": "San Marino",
        "code": "378",
        "iso": "SM",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Sao Tome and Principe",
        "code": "239",
        "iso": "ST",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Saudi Arabia",
        "code": "966",
        "iso": "SA",
        "isTransactions": true ,
        "languages": ["en","ar"],
        "phoneLength": 9
    },
    {
        "country": "Senegal",
        "code": "221",
        "iso": "SN",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Serbia",
        "code": "381",
        "iso": "RS",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Seychelles",
        "code": "248",
        "iso": "SC",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Sierra Leone",
        "code": "232",
        "iso": "SL",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Singapore",
        "code": "65",
        "iso": "SG",
        "isTransactions": true ,
        "languages": ["en","hi","ta","zh","bn","th","id","my"],
        "phoneLength": 8
    },
    {
        "country": "Sint Maarten",
        "code": "1-721",
        "iso": "SX",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Slovakia",
        "code": "421",
        "iso": "SK",
        "isTransactions": true,
        "languages": ["en","sk"],
        "phoneLength": 9
    },
    {
        "country": "Slovenia",
        "code": "386",
        "iso": "SI",
        "isTransactions": true,
        "languages": ["en","sl"],
        "phoneLength": 9
    },
    {
        "country": "Solomon Islands",
        "code": "677",
        "iso": "SB",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Somalia",
        "code": "252",
        "iso": "SO",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "South Africa",
        "code": "27",
        "iso": "ZA",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "South Korea",
        "code": "82",
        "iso": "KR",
        "isTransactions": false,
        "phoneLength": 10
    },
    {
        "country": "South Sudan",
        "code": "211",
        "iso": "SS",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Spain",
        "code": "34",
        "iso": "ES",
        "isTransactions": true ,
        "languages": ["en","es"],
        "phoneLength": 9
    },
    {
        "country": "Sri Lanka",
        "code": "94",
        "iso": "LK",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Sudan",
        "code": "249",
        "iso": "SD",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Suriname",
        "code": "597",
        "iso": "SR",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Svalbard and Jan Mayen",
        "code": "47",
        "iso": "SJ",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Swaziland",
        "code": "268",
        "iso": "SZ",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Sweden",
        "code": "46",
        "iso": "SE",
        "isTransactions": true,
        "languages": ["en","sv"],
        "phoneLength": 9
    },
    {
        "country": "Switzerland",
        "code": "41",
        "iso": "CH",
        "isTransactions": true,
        languages: ["en","de","it","fr"],
        "phoneLength": 9
    },
    {
        "country": "Syria",
        "code": "963",
        "iso": "SY",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Taiwan",
        "code": "886",
        "iso": "TW",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Tajikistan",
        "code": "992",
        "iso": "TJ",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Tanzania",
        "code": "255",
        "iso": "TZ",
        "isTransactions": false,
        "languages": ["en","vi"],
        "phoneLength": 9
    },
    {
        "country": "Thailand",
        "code": "66",
        "iso": "TH",
        "isTransactions": true,
        "languages": ["en","th","my"],
        "phoneLength": 9
    },
    {
        "country": "Togo",
        "code": "228",
        "iso": "TG",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Tokelau",
        "code": "690",
        "iso": "TK",
        "isTransactions": false,
        "phoneLength": 4
    },
    {
        "country": "Tonga",
        "code": "676",
        "iso": "TO",
        "isTransactions": false,
        "phoneLength": 5
    },
    {
        "country": "Trinidad and Tobago",
        "code": "1-868",
        "iso": "TT",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Tunisia",
        "code": "216",
        "iso": "TN",
        "isTransactions": false,
        "phoneLength": 8
    },
    {
        "country": "Turkey",
        "code": "90",
        "iso": "TR",
        "isTransactions": false,
        "languages": ["en","tr"],
        "phoneLength": 10
    },
    {
        "country": "Turkmenistan",
        "code": "993",
        "iso": "TM",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Turks and Caicos Islands",
        "code": "1-649",
        "iso": "TC",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Tuvalu",
        "code": "688",
        "iso": "TV",
        "isTransactions": false,
        "phoneLength": 5
    },
    {
        "country": "U.S. Virgin Islands",
        "code": "1-340",
        "iso": "VI",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Uganda",
        "code": "256",
        "iso": "UG",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Ukraine",
        "code": "380",
        "iso": "UA",
        "isTransactions": false,
        "languages": ["en","ru","uk"],
        "phoneLength": 9
    },
    {
        "country": "United Arab Emirates",
        "code": "971",
        "iso": "AE",
        "isTransactions": true,
        "languages": ["en","ar"],
        "phoneLength": 9
    },
    {
        "country": "United Kingdom",
        "code": "44",
        "iso": "GB",
        "isTransactions": true,
        "languages": ["en","ro"],
        "phoneLength": 10
    },
    {
        "country": "United States",
        "code": "1",
        "iso": "US",
        "isTransactions": true,
        "languages": ["en","es"],
        "phoneLength": 10
    },
    {
        "country": "Uruguay",
        "code": "598",
        "iso": "UY",
        "isTransactions": false,
        "languages": ["en","es"],
        "phoneLength": 8
    },
    {
        "country": "Uzbekistan",
        "code": "998",
        "iso": "UZ",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Vanuatu",
        "code": "678",
        "iso": "VU",
        "isTransactions": false,
        "phoneLength": 7
    },
    {
        "country": "Vatican",
        "code": "379",
        "iso": "VA",
        "isTransactions": false,
        "phoneLength": 6
    },
    {
        "country": "Venezuela",
        "code": "58",
        "iso": "VE",
        "isTransactions": false,
        "languages": ["en","es"],
        "phoneLength": 10
    },
    {
        "country": "Vietnam",
        "code": "84",
        "iso": "VN",
        "isTransactions": false,
        "languages": ["en","vi"],
        "phoneLength": 9
        
    },
    {
        "country": "Wallis and Futuna",
        "code": "681",
        "iso": "WF",
        "isTransactions": false,
        "phoneLength": 6
    },
    {
        "country": "Western Sahara",
        "code": "212",
        "iso": "EH",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Yemen",
        "code": "967",
        "iso": "YE",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Zambia",
        "code": "260",
        "iso": "ZM",
        "isTransactions": false,
        "phoneLength": 9
    },
    {
        "country": "Zimbabwe",
        "code": "263",
        "iso": "ZW",
        "isTransactions": false,
        "phoneLength": 9

    }
]